'use client';
import * as React from 'react';
export function useAccordionHeaderContextValues_unstable(state) {
    const { disabled, expandIconPosition, open, size } = state;
    const accordionHeader = React.useMemo(()=>({
            disabled,
            expandIconPosition,
            open,
            size
        }), [
        disabled,
        expandIconPosition,
        open,
        size
    ]);
    return {
        accordionHeader
    };
}
